export default "__VITE_ASSET__8e1swIvz__"